import { GuidToString, type StringGUID, UUID } from "@pdfking/tfunc"

export default (): StringGUID => GuidToString(UUID())
